import { isColor, isGradient } from '../../../../theme';
export const withColors = ({ theme, ...props }) => {
    const rules = {};
    if (props.background) {
        if (isColor(props.background)) {
            rules.background = theme.colors[props.background];
        }
        else if (isGradient(props.background)) {
            rules.background = theme.gradients[props.background];
        }
        else {
            rules.background = props.background;
        }
    }
    if (props.color) {
        rules.color = isColor(props.color) ? theme.colors[props.color] : props.color;
    }
    if (props.colorHovered) {
        rules['&:hover'] = {
            color: isColor(props.colorHovered) ? theme.colors[props.colorHovered] : props.colorHovered,
        };
    }
    if (props.backgroundHovered) {
        const { backgroundHovered } = props;
        let value = backgroundHovered;
        if (isColor(props.backgroundHovered)) {
            value = theme.colors[props.backgroundHovered];
        }
        if (isGradient(props.backgroundHovered)) {
            value = theme.gradients[props.backgroundHovered];
        }
        rules['&:hover'] = {
            background: value,
        };
    }
    return rules;
};
